/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetEventsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetEventsArgs, useGetEventsSpec, useGetEventsRealtime, useGetEventsPagination } from '../specs/events.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetEventsRow } from '../openapi-types.gen.js';
export type { useGetEventsArgs } from '../specs/events.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetEventsPaginationContract = useGetEventsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetEventsInfinite` — both
 * read/write the same `PagedData<GetEventsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): limit, cursor, activeOnly.
 */
const _useGetEvents = createListHook({
  spec: useGetEventsSpec,
  realtime: useGetEventsRealtime,
  entityKey: null,
  pagination: _useGetEventsPaginationContract,
});
export const useGetEvents = _useGetEvents as (args: useGetEventsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetEvents>;


/**
 * Auto-infinite: same cache as `useGetEvents`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetEvents` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetEventsInfinite = createListHook({
  spec: useGetEventsSpec,
  realtime: useGetEventsRealtime,
  entityKey: null,
  pagination: _useGetEventsPaginationContract,
  autoLoadMore: true,
});
export const useGetEventsInfinite = _useGetEventsInfinite as (args: useGetEventsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetEventsInfinite>;


/**
 * Per-field subscription hook for the `useGetEvents` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetEventsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetEventsField = createFieldHook<GetEventsRow>('useGetEventsField');

/**
 * Hover/intent prefetch companion for `useGetEvents` (also covers
 * `useGetEventsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetEvents();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetEvents = createPrefetchHook(useGetEventsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetEventsArgs>;
